import React from 'react';
import { IconPropsDeprecated, RGBString } from '@umanforge/common';
import { PlaniteamSVG } from 'images/planiteam.svg';

interface PlaniteamIconPropsDeprecated extends IconPropsDeprecated {
  color?: RGBString;
}

const PlaniteamIcon: React.FC<PlaniteamIconPropsDeprecated> = ( { className = '', size = 6, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <PlaniteamSVG />
    </div>
  );
};

export { PlaniteamIcon };
